import { ServiceHandler } from '../../utils';

export const getInsightById = ServiceHandler({
  url: '/api/risk/v1/recommendations/:spotlightId',
  method: 'GET',
});

export const updateInsightByProduct = ServiceHandler({
  url: '/api/risk/v1/recommendations/:spotlightId',
  method: 'PATCH',
});

export const contactCyberExpertRequestedEmail = ServiceHandler({
  url: '/api/risk/v1/recommendations/:spotlightId/contact-cyber-expert/:productName',
  method: 'POST',
});

export const sendEmailToDeclineProducts = ServiceHandler({
  url: '/api/risk/v1/recommendations/:spotlightId/send-decline-email',
  method: 'POST',
});
